import * as actionTypes from './actionTypes';
import axios from 'axios';

const IDENTITY = process.env.REACT_APP_IDENTITY_API_URL;

//post reset password data
export const postForgotPasswordData = (data) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.POST_FORGOT_PASSWORD_LOADING
        })
        let apiUrl =  IDENTITY +'/forgotpassword';
        axios.post(apiUrl,data)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    dispatch({
                        type: actionTypes.POST_FORGOT_PASSWORD_SUCCESS,
                        forgotPassword: response.data
                    });
                }
            })
            .catch(error => {
                let errMsg  = error;
                if(error.response && error.response.data.errorMessage){
                    errMsg = error.response.data.errorMessage;
                }
                dispatch({
                    type: actionTypes.POST_FORGOT_PASSWORD_ERROR,
                    error: errMsg
                });
            });
    };
}